import React from 'react';
import antidoteLogoSrc from 'shared/images/antidote-logo-black.png';
import { Link } from 'react-router-dom';

export function AntidoteLogoBranding () {
  return (
    <Link to="/">
      <img src={antidoteLogoSrc} style={{ width: '10rem' }} />
    </Link>
  )
}
